import React from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";
import { colors } from "utils";
import { logError, LogCategory } from "utils/sentryLogger";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logError("Activity render error", error, {
      category: LogCategory.ACTIVITY,
      componentStack: errorInfo?.componentStack,
    });
  }

  handleRejoin = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return typeof this.props.fallback === "function"
          ? this.props.fallback({ error: this.state.error, resetError: this.handleRejoin })
          : this.props.fallback;
      }

      return (
        <Overlay>
          <Card>
            <Heading>Something went wrong</Heading>
            <Message>
              Don't worry, your progress is saved. Click below to rejoin the session.
            </Message>
            <RejoinButton onClick={this.handleRejoin}>
              Rejoin Session
            </RejoinButton>
          </Card>
        </Overlay>
      );
    }

    return this.props.children;
  }
}

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.milkGlass500};
  z-index: 9999;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 48px;
  max-width: 420px;
  text-align: center;
`;

const Heading = styled.h2`
  font-size: 28px;
  font-weight: 600;
  color: ${colors.nightlyWoods950};
  margin: 0;
`;

const Message = styled.p`
  font-size: 16px;
  color: ${colors.nightlyWoods500};
  margin: 0;
  line-height: 1.5;
`;

const RejoinButton = styled(Button)`
  background-color: ${colors.blue500};
  border: none;
  border-radius: 100px;
  color: white;
  font-weight: 500;
  padding: 12px 32px;
  margin-top: 8px;

  &:hover {
    background-color: ${colors.blue500};
    opacity: 0.9;
  }
`;
